import * as Immutable from "immutable";
import { ParamValue } from "./paramValue";

export class MultiChoiceValue extends ParamValue 
{
  protected readonly THREE_STATE = "threeState";

  get threeState(): boolean { return this.getInternalValue<boolean>(this.THREE_STATE); }
  setThreeState(threeState: boolean): this { return this.setInternalValue(this.THREE_STATE, threeState); }
}